<template>
  <VCard>
    <VCardTitle class="pa-6">
      Secure File Upload
    </VCardTitle>
    
    <VDivider />
    
    <VCardText class="pa-6">
      <SecureFileUploadForm
        :showEmailPasswordFields="true"
        :showPasswordGenerator="true"
      />
    </VCardText>
  </VCard>
</template>

<script setup>
import SecureFileUploadForm from '@/components/common/SecureFileUploadForm.vue'

definePage({ meta: { requiresAuth: true } });
</script>
